<template>
	<tr :class="[{ 'transient' : rowdata.processing, 'new': rowdata.id == '', 'remove': rowdata.savePending == 'delete' }, customTRClasses]">
		<slot name="select"></slot>
		<td v-for="( column, columnIdx ) in columns"
				:key="'column-' + columnIdx"
				v-show="showColumn( column )"
				:class="column.columnClass"
				tabindex="0">

			<slot :name="column.customCol">
				<span v-if="column.type === 'index'">
					{{ rowIndex + 1 }}
				</span>

				<span v-else-if="column.type === 'link' && useAnchor">
					<a :href="getFullLink( column.link )">
						{{ formatValue(column.type, getProp(rowdata, column.key)) }}
					</a>
				</span>

				<span v-else-if="column.type === 'link' && !useAnchor">
					<router-link :to="rowdata.LINK">
						{{ formatValue(column.type, getProp(rowdata, column.key)) }}
					</router-link>
				</span>

				<span v-else-if="column.type === 'count'">
					<span class="badge badge-primary">{{ getProp( rowdata, column.key ).length }}</span>
				</span>

				<span v-else-if="column.type === 'list'">
					<ul>
						<li v-for="(li, index) in getProp(rowdata, column.key)" :key="`rowData_${index}`">
							{{ li }}
						</li>
					</ul>
				</span>

				<span v-else-if="column.type === 'html'" v-html="'<div>' + formatValue(column.type, getProp(rowdata, column.key))+ '</div>'">
				</span>

				<div v-else-if="column.type === 'bar'">
					<div class="col-xs-10">
						<div class="progress">
							<div class="progress-bar"
									 role="progressbar"
									 aria-valuenow="60"
									 aria-valuemin="0"
									 aria-valuemax="100"
									 :style="{ width: rowdata[column.key] + '%' }" :class="getProgressClass(rowdata[column.key])">
							</div>
						</div>
					</div>
					<div class="col-xs-2">
						<span class="text-lg"><strong>{{ rowdata[column.key] }}</strong></span>
					</div>
				</div>

				<span v-else :class="column.contentClass">
					{{ formatValue(column.type, getProp(rowdata, column.key)) }}
				</span>
			</slot>
		</td>
		<td v-if="showActions" class="action-column" tabindex="0">
			<slot name="actions"></slot>
		</td>
	</tr>
</template>

<script>
	import moment from 'moment';
	import _ from 'lodash';

	export default {
		name: 'TableListRow',
		props: {
			columns: Array,
			showColumns: {
				type: Array,
				default: function() {
					return []
				}
			},
			showActions: {
				type: Boolean,
				default: true
			},
			rowIndex: Number,
			rowdata: Object,
			rootURL: {
				type: String,
				default: ''
			},
			useAnchor: {
				type:			Boolean,
				default:	true
			},
			customTRClasses: {
				type:			Object,
				default:	function() {
					return {};
				}
			}
		},
		methods: {
			getProp(object, keys, defaultVal) {
				return _.get( object, keys ) ;
			},
			formatValue(cellType, value) {
				switch(cellType) {
					case 'decimal':
						{
							if(value !== '') {
								return parseFloat(value).toFixed(2);
							} else {
								return value;
							}
						}
						break;
					case 'date':
						{
							let date = moment(value);

							if(date.isValid()) {
								return date.format('MMM DD, YYYY');
							}
							return value;
						}
						break;
					case 'datetime':
						{
							let date = moment(value);

							if(date.isValid()) {
								return date.format('MMM DD, YYYY h:mm a');
							}
							return value;
						}
						break;
					default:
						return value;
				}
			},
			getFullLink(oLink) {
				let linkRoot = '';
				let fullURL = oLink.url;

				if(oLink.hasRoot) {
					linkRoot = this.rootURL;
				}

				if(oLink.isLinkUnique) {
					fullURL = String( linkRoot ) + String( oLink.url );
				}

				return fullURL;
			},
			showColumn(column) {
				if(this.showColumns.length === 0) { return true; }

				let exists = this.showColumns.map(function(e) {return e.key;}).indexOf(column.key);

				return exists >= 0 ? true : false;
			},
			getProgressClass(percent) {
				let theClass = '';

				if( percent <= 50) {
					theClass = 'progress-bar-danger'
				} else if(percent > 50 && percent <= 75) {
					theClass = 'progress-bar-warning'
				} else {
					theClass = 'progress-bar-success'
				}

				return theClass;
			}
		}
	}
</script>

<style scoped>
	tr.new td {
		background: #D7F6C5;
	}

	tr.remove td {
		background: #FFCBC4;
	}
</style>
